'use client';

interface Props {
  title: string;
  description?: string;
  bottom?: React.ReactNode;
  icon?: React.ReactNode;
}
export const EmptyState = ({ title, description, bottom, icon }: Props) => {
  return (
    <>
      <div className="flex flex-col min-h-[200px] flex-grow p-3 h-full w-full gap-3 items-center justify-center">
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="w-[300px] h-[300px] flex items-end">{icon}</div>
          <div className="flex flex-col gap-1">
            <h3 className="text-xl font-bold tracking-tight">{title}</h3>
            {description && (
              <p className="text-sm text-muted-foreground">{description}</p>
            )}
          </div>
        </div>
        {bottom}
      </div>
    </>
  );
};
